module.exports = __webpack_public_path__ + "media/images/icons/person-outline-65d13c27e4d4ee734055d90a8287f4bd.svg";